import { createBrowserHistory } from 'history';

// A singleton history object for easy API navigation
export const history = createBrowserHistory({ basename: process.env.PUBLIC_URL || null });
